import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Material } from './Material.js';
import { Color } from '../math/Color.js';
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */

var ShadowMaterial = /*#__PURE__*/function (_Material) {
  _inheritsLoose(ShadowMaterial, _Material);

  function ShadowMaterial(parameters) {
    var _this;

    _this = _Material.call(this) || this;
    _this.type = 'ShadowMaterial';
    _this.color = new Color(0x000000);
    _this.transparent = true;

    _this.setValues(parameters);

    return _this;
  }

  var _proto = ShadowMaterial.prototype;

  _proto.copy = function copy(source) {
    _Material.prototype.copy.call(this, source);

    this.color.copy(source.color);
    return this;
  };

  return ShadowMaterial;
}(Material);

ShadowMaterial.prototype.isShadowMaterial = true;
export { ShadowMaterial };